import { Tools } from "@comunicare/comunicare-helper";
import { AbstractEntitylink, IEntitylink } from "@comunicare/comunicare-interfaces";

export class Entitylink extends AbstractEntitylink implements IEntitylink {
  protected genId(): string {
    return Tools.genValidId();
  }
}
